<template>
  <v-content>
    <v-container fluid>
      <v-row v-for="datas in courses" :key="datas.course_id">
      <v-col cols="12" >
        <v-card raised>
          <v-card>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-card-title class="headline">
                    {{ datas.course_name }}
                    <v-spacer></v-spacer>
                  <v-btn
                    text
                    color
                  >{{ (currentUser.company.account_type == "on-demand" ? datas.plan.amount : 'Included' ) | translate }} <v-icon small v-if='currentUser.company.account_type == "on-demand" && datas.plan.amount !== null && datas.plan.currency == "eur"'>mdi-currency-eur</v-icon><v-icon v-else-if='currentUser.company.account_type == "on-demand" && datas.plan.amount !== null'>$</v-icon></v-btn>

                    <v-btn :color="primary_color" style='color:white;' @click='checkCard(datas.course_id)' v-if='datas.is_subscribed == false'>{{ 'Subscribe'| translate }}</v-btn>
                    <v-btn color="success" style='color:white;'  v-if='datas.is_subscribed == true'>{{ 'Subscribed'| translate }}</v-btn>
                  </v-card-title>                  
                </v-col>
                <v-col cols="8">
                  <v-card-subtitle class="pt-5" v-html='datas.description'></v-card-subtitle>
                  <v-row>
                    <v-col cols="6">
                      <h5>{{ 'Modules' | translate }}</h5>
                      <v-chip-group mandatory column>
                        <v-chip v-for='(moduledata,index) in datas.company_modules' :key='index' :to="'/modules/'+moduledata.module_id" >
                          {{ moduledata.title }}
                        </v-chip>             
                      </v-chip-group> 
                    </v-col>
                    <v-col cols="6">
                      <h5>{{ 'Documents' | translate }}</h5>
                      <v-chip-group mandatory column>
                        <v-chip v-for='(documents,index) in datas.general_documents' :key='index' :to="'/documents/'+documents.hash_id">
                          {{ documents.gendoc_name }}
                        </v-chip>                  
                      </v-chip-group>  
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="4">
                      <v-row>
                        <v-col cols="12" sm="12">
                          <v-img
                            :src="storage_url+datas.course_image"
                            aspect-ratio="1"
                            class="grey lighten-2"
                            max-width="500"
                            max-height="300"
                          ></v-img>
                        </v-col>
                      </v-row>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-card>
      </v-col>


      </v-row>

    </v-container>

    <v-dialog v-if="!loadingdata" v-model="dialog" persistent max-width="450">
      <v-card>
        <v-card-title class="headline">{{ 'Are you sure you want to purchase?' | translate }}</v-card-title>
        <v-card-text></v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary darken-1" text @click="dialog = false">{{ 'No' | translate }}</v-btn>
          <v-btn color="primary darken-1" text @click="subscribe(course_id)">{{ 'Yes' | translate }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="profileLink" persistent max-width="600">
      <v-card>
        <v-card-title
          class="headline"
        >{{ 'You dont seem to have a card added to your profile' | translate }}</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary darken-1" text to="/profile">{{ 'Go to profile' | translate }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
   <v-overlay :value="loadingdata && routerenter">
      <v-layout row justify-center v-if="loadingdata">
        <v-dialog v-model="loadingdata" persistent fullscreen content-class="loading-dialog">
          <v-container fill-height>
            <v-layout row justify-center align-center>
              <v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
            </v-layout>
          </v-container>
        </v-dialog>
      </v-layout>
    </v-overlay>
  </v-content>
</template>

<script>
import { mapGetters } from "vuex";
import store from "@/store";
import {
  FETCH_COURSES,
  AUTO_RENEWAL_OFF,
  COURSE_SUBSCRIBE,
  RESET_STATE
} from "@/store/actions.type";
import { SET_LOADING, SET_ROUTER_ENTER } from "@/store/mutations.type";
export default {
  name: "ModulesDetails",
   beforeRouteEnter(to, from, next) {
    store.dispatch(RESET_STATE);
    store.commit(SET_ROUTER_ENTER)
    store.dispatch(FETCH_COURSES, '').then(resp => {
      if (resp.success) {
        store.commit(SET_LOADING, false);
      }
    });

    return next();
  },
  computed: {
    ...mapGetters([
      "courses",
      "stripesecretkey",
      "currentUser",
      "loadingdata",
      'routerenter',
      "languages"
    ])
  },
  created() {
    this.storage_url  = process.env.VUE_APP_STORAGE_URL
    let companymeta = JSON.parse(this.currentUser.company.company_meta);
    this.primary_color = companymeta.primary_color;
  },
  data: function() {
    return {
      course_id: null,
      dialog: false,
      storage_url: '',
      primary_color:'',
      profileLink: false,    };
  },
  methods: {
    checkCard(id) {
      if (this.currentUser.company.account_type == "on-demand") {
        if (this.currentUser.card_brand !== null) {
          this.dialog = true;
          this.course_id = id
        } else {
          this.profileLink = true;
        }
      } else if (this.currentUser.company.account_type == "full-version") {
        this.$store.dispatch(COURSE_SUBSCRIBE, id).then(resp => {
          if (resp.success) {
              this.$store.dispatch(FETCH_COURSES, '').then(resp => {
                if (resp.success) {
                  store.commit(SET_LOADING, false);
                }
              }); 
          }
        });
      }
    },
    gottoCourse(){
      this.$router.push("/courses");
    },
    subscribe(id) {
      if (this.currentUser.company.account_type == "on-demand") {
        this.$store.dispatch(COURSE_SUBSCRIBE, id).then(resp => {
          if (resp.success) {
            store.dispatch(AUTO_RENEWAL_OFF, id).then(() => {
              this.dialog = false;
              this.$store.dispatch(FETCH_COURSES, '').then(resp => {
                if (resp.success) {
                  store.commit(SET_LOADING, false);
                }
              });              
            });
          }
        });
      } else {
        this.$store.dispatch(COURSE_SUBSCRIBE, id).then(resp => {
          if (resp.success) {
              this.$store.dispatch(FETCH_COURSES, '').then(resp => {
                if (resp.success) {
                  store.commit(SET_LOADING, false);
                }
              }); 
          }
        });
      }
    }
  }
};
</script>